import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map, startWith } from 'rxjs/operators';
import { NAV_ITEMS } from './nav-items';

const EXTRA_ROUTES: Record<string, string> = {
  '/profile':              'nav.myProfile',
  '/admin/org-structure':  'sidebar.orgStructure',
};

@Injectable({ providedIn: 'root' })
export class PageTitleService {
  private readonly router = inject(Router);

  readonly titleKey = toSignal(
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      map(() => this.resolve(this.router.url)),
      startWith(this.resolve(this.router.url)),
    ),
    { initialValue: 'app.title' },
  );

  private resolve(url: string): string {
    const cleanUrl = url.split('?')[0];

    if (EXTRA_ROUTES[cleanUrl]) return EXTRA_ROUTES[cleanUrl];

    for (const item of NAV_ITEMS) {
      if (item.children) {
        const match = item.children.find(child =>
          child.exact ? cleanUrl === child.route : cleanUrl.startsWith(child.route),
        );
        if (match) return match.labelKey;
      } else if (item.route) {
        const matches = item.exact ? cleanUrl === item.route : cleanUrl.startsWith(item.route);
        if (matches) return item.labelKey;
      }
    }

    return 'app.title';
  }
}
